import { Flex, Skeleton, SkeletonBox, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import ChangeBadge from '../../ChangeBadge/ChangeBadge';

export type ComparisonValue = {
  change: number | null;
  currentValue: string;
  isFetching: boolean;
  positiveDelta?: 1 | -1;
};

type Props = ComparisonValue & {
  title: string;
};

const OverviewComparisonItem: FunctionComponent<Props> = ({
  change,
  currentValue,
  isFetching,
  positiveDelta,
  title,
}) => (
  <Flex borderColor="gray-2" borderRadius="x4" paddingHorizontal="x5" paddingVertical="x4">
    <Skeleton>
      <Flex
        direction="horizontal"
        alignChildrenVertical="middle"
        alignChildrenHorizontal="middle"
        gap="x2"
        margin="x2"
      >
        {isFetching ? (
          <SkeletonBox height="2rem" width="4rem" />
        ) : (
          <Text config="5">{currentValue}</Text>
        )}

        {isFetching ? (
          <SkeletonBox height="2rem" width="4rem" />
        ) : (
          <ChangeBadge change={change} positiveDelta={positiveDelta} />
        )}
      </Flex>

      {isFetching ? (
        <Flex direction="horizontal" alignChildrenHorizontal="middle">
          <SkeletonBox height="1rem" width="7rem" />
        </Flex>
      ) : (
        <Text config="9" align="middle">
          {title}
        </Text>
      )}
    </Skeleton>
  </Flex>
);

export default OverviewComparisonItem;
